'use client'

import { ReactNode, useContext } from "react"
import { ToC } from "../wysiwyg/ToC"
import { Body } from "../Body"
import { DrupalNodeBasicPage } from "@/types"
import { PreviewBarContext } from "./PreviewBarClient"
import HtmlDiff from 'htmldiff-js';

export const PageContent = ({resource, revision, inDraft, children}: {
  resource: DrupalNodeBasicPage
  revision: DrupalNodeBasicPage | null
  inDraft: boolean
  children: ReactNode
}) => {

  const previewMode = useContext(PreviewBarContext)
  const node = revision ?? resource

  const bodyContent = !inDraft ? node.body.processed :
    (previewMode == 'revision' && node.body.processed) 
    || 
    (previewMode == 'current' && resource.body.processed)
    ||
    (previewMode == 'diff' && HtmlDiff.execute(resource.body.processed, revision?.body.processed ?? ''))
    || 
    null

  // Boolean on whether to use the ToC or not.
  const useToC = bodyContent?.match('id="contents"') !== null;
  const main_span = useToC ? 'col-span-2' : 'col-span-3'

  return (
    <>
      {useToC && (
        <div className="order-last">
          <ToC className="order-last col-span-1 sticky top-4 self-start hover:overscroll-y-contain overflow-y-auto h-screen toc" />
        </div>
      )}
      <div className={`meta-content ${main_span} mode-${previewMode}`}>
          {children}
          <Body value={bodyContent || ''} sectionScroll={true} className="max-w-4xl"  />
      </div>
    </>
  )
}